import { SharedModule } from "./../../../shared/shared.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { ExerciseModalPageRoutingModule } from "./exercise-modal-routing.module";

import { ExerciseModalPage } from "./exercise-modal.page";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ExerciseModalPageRoutingModule,
    SharedModule,
  ],
  providers: [],
  declarations: [ExerciseModalPage],
})
export class ExerciseModalPageModule {}
